import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ModalElegirInstitution from "../../../Modals/ModalElegirInstitution/ModalElegirInstitution";
import axios from "axios";
import API_BASE_URL from "../../../../config/config.js";
import { getColorById } from "../../../../utils/colorSport.js";
const Grupos = ({
  config,
  participantes,
  setParticipantes,
  sembradoUpdated,
  groupSizes,
  setGroupSizes,
}) => {
  const { idevent, idsport } = useParams();
  const [open, setOpen] = useState(false);
  const [selectedGrupo, setSelectedGrupo] = useState(null);
  const [selectedNroGrupo, setSelectedNroGrupo] = useState(null);
  const [selectedInstitution, setSelectedInstitution] = useState(null);
  const [sembrado, setSembrado] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [loading, setLoading] = useState(false); // Estado de carga
  const [color, setColor] = useState("#000000"); // Estado del color

  useEffect(() => {
    if (idsport) {
      setColor(getColorById(Number(idsport)));
    }
  }, [idsport]);

  const grupos = Array.from(
    { length: config.nro_grupos },
    (_, i) => `GRUPO ${String.fromCharCode(65 + i)}`
  );

  const handleOpenModal = (grupo, nroGrupo, institution) => {
    const region = sembrado.find(
      (s) => s.idgroup === grupo && s.nro_grupo === nroGrupo
    )?.idregion;
    setSelectedGrupo(grupo);
    setSelectedNroGrupo(nroGrupo);
    setSelectedInstitution(institution);
    setSelectedRegion(region);
    setOpen(true);
  };

  useEffect(() => {
    if (config.useSembradoRegional || sembradoUpdated) {
      const getSembrado = async () => {
        try {
          setLoading(true); // Empezar a cargar
          const response = await axios.post(`${API_BASE_URL}/getsembrado`, {
            idevent: Number(idevent),
            idsport: Number(idsport),
          });
          console.log("Sembrado", response.data);
          setSembrado(response.data);

          // Actualizar groupSizes basándonos en el sembrado
          if (response.data.length > 0) {
            const newGroupSizes = Array(config.nro_grupos).fill(0);

            response.data.forEach((item) => {
              newGroupSizes[item.idgroup - 1]++; // Contar cuántos participantes hay por grupo
            });

            setGroupSizes(newGroupSizes); // Actualizar el estado de groupSizes
          }
        } catch (error) {
          console.error("Error fetching sembrado", error);
        } finally {
          setLoading(false); // Detener la carga
        }
      };
      if (idevent && idsport) {
        getSembrado();
      }
    }
  }, [config.useSembradoRegional, sembradoUpdated, idevent, idsport]);

  const getRegionName = (idregion) => {
    switch (idregion) {
      case 1:
        return "Lima";
      case 2:
        return "Sur";
      case 3:
        return "Norte";
      case 4:
        return "Centro";
      default:
        return "Desconocido";
    }
  };

  return (
    <div
      className="p-4"
      // style={
      //   idevent === "80"
      //     ? {
      //       backgroundImage: "url('/assets/background/bg_universiada.png')",
      //       backgroundSize: "cover",
      //       backgroundPosition: "center",
      //       minHeight: "100vh",
      //       fontWeight: "bold",
      //     }
      //     : {}
      // }
    >
      {loading ? (
        <div className="text-center">Cargando sembrado de regiones...</div> // Indicador de carga
      ) : (
        <div
          className={`p-4 grid gap-4 ${config.nro_grupos === 1
              ? "grid-cols-1 justify-center"
              : config.nro_grupos === 2
                ? "grid-cols-1 md:grid-cols-2 justify-center"
                : "grid-cols-1 md:grid-cols-3"
            }`}
        >
          {grupos.map((grupo, index) => {
            const grupoParticipantes = participantes
              .filter((p) => p.idgrupo === index + 1)
              .sort((a, b) => a.nro_grupo - b.nro_grupo);

            const grupoSembrado = sembrado.filter(
              (s) => s.idgroup === index + 1
            );

            // Determinar la cantidad de filas a mostrar
            const filasAMostrar =
              config.useSembradoRegional && groupSizes[index] !== undefined
                ? groupSizes[index]
                : Math.ceil(
                  config.nro_instituciones_participantes / config.nro_grupos
                );

            return (
              <div
                key={index}
                className={`bg-white rounded-lg shadow-md p-4 ${config.nro_grupos === 1 || config.nro_grupos === 2
                    ? "mx-auto w-full max-w-md"
                    : ""
                  }`}
                style={
                  idevent === "80"
                    ? { backgroundColor: "rgba(255, 255, 255, 0.65)" }
                    : {}
                }
              >
                <h2
                  className="text-center mb-2"
                  style={
                    idevent === "80"
                      ? {
                        backgroundColor: color,
                        color: "#ffffff",
                        fontWeight: "bold",
                        padding: "8px",
                        borderRadius: "4px",
                        fontSize: "1.5rem",
                        letterSpacing: "1px",
                      }
                      : { fontWeight: "normal" }
                  }
                >
                  {config.useSembradoRegional && groupSizes[index] != null
                    ? `${grupo} (${groupSizes[index]} equipos)`
                    : grupo}
                </h2>
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                  <tbody>
                    {Array.from({ length: filasAMostrar }).map((_, idx) => {
                      const participante = grupoParticipantes.find(
                        (p) => p.nro_grupo === idx + 1
                      );

                      const sembradoData = grupoSembrado.find(
                        (s) => s.nro_grupo === idx + 1
                      );

                      return (
                        <tr
                          key={idx}
                          className="transition transform hover:scale-105 cursor-pointer"
                          onClick={() =>
                            handleOpenModal(
                              index + 1,
                              idx + 1,
                              participante?.Institution
                            )
                          }
                        >
                          <td
                            className="px-2 py-3 whitespace-nowrap relative"
                            style={
                              idevent === "80"
                                ? {
                                  backgroundColor:
                                    "rgba(255, 255, 255, 0.01)",
                                  minHeight: "60px",
                                }
                                : {}
                            }
                          >
                            <div className="flex items-center justify-center">
                              {config.useSembradoRegional &&
                                groupSizes[index] !== undefined ? (
                                <span
                                  className="absolute left-0 text-xs font-semibold"
                                  style={{
                                    fontSize: "1.15rem",
                                    color: "#000000",
                                  }}
                                >
                                  {idx + 1}
                                </span>
                              ) : !config.useSembradoRegional ? (
                                <span
                                  className="absolute left-0 text-xs font-semibold"
                                  style={{ color: "#000000" }}
                                >
                                  {idx + 1}
                                </span>
                              ) : null}
                              <div
                                className="relative ml-4"
                                style={
                                  idevent !== "80"
                                    ? {
                                      width: "40px",
                                      height: "40px",
                                      minWidth: "40px",
                                      minHeight: "40px",
                                    }
                                    : undefined // No aplicar estilos cuando idevent es "80"
                                }
                              >
                                {participante &&
                                  participante.idgrupo &&
                                  participante.Institution.image_path ? (
                                  <>
                                    <img
                                      src={`${participante.Institution.path_base}${participante.Institution.image_path}`}
                                      alt="Logo"
                                      className={`rounded-full object-cover ${idevent === "80"
                                          ? "w-14 h-14"
                                          : "w-10 h-10"
                                        }`} // Ajuste de tamaño del logo
                                      style={{
                                        width: "40px !important",
                                        height: "40px !important",
                                      }}
                                    />
                                    {idevent !== "80" &&
                                      config &&
                                      config.useBandera && (
                                        <div
                                          className="absolute bottom-6 left-7 bg-gray-300"
                                          style={{
                                            width: "30px",
                                            height: "20px",
                                            transform: "scale(0.5)",
                                          }}
                                        >
                                          <img
                                            src={
                                              participante.Institution.country
                                                .img_path
                                            }
                                            alt="Bandera"
                                            className="w-full h-full object-cover"
                                          />
                                        </div>
                                      )}
                                  </>
                                ) : (
                                  <div className="w-10 h-10 rounded-full bg-gray-200 invisible"></div>
                                )}
                              </div>
                            </div>
                          </td>
                          {idevent !== "80" && participante && (
                            <td
                              className="px-2 py-3 whitespace-normal"
                              style={
                                idevent === "80"
                                  ? {
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.01)",
                                  }
                                  : {}
                              }
                            >
                              {participante.Institution.name}
                            </td>
                          )}
                          {participante ? (
                            <td
                              className={`px-2 py-3 whitespace-normal ${idevent === "80" ? "text-2xl" : ""
                                }`} // Ajuste de tamaño del texto si idevent es 80
                              style={
                                idevent === "80"
                                  ? {
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.01)",
                                    color: "#000000",
                                  }
                                  : {}
                              }
                            >
                              {participante.Institution.abrev}
                            </td>
                          ) : sembradoData ? (
                            <td
                              className="px-2 py-3 whitespace-normal text-center text-2xl"
                              style={
                                idevent === "80"
                                  ? {
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.01)",
                                    minHeight: "60px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transform: "translateX(-80px)",
                                    color: "#000000",
                                  }
                                  : {}
                              }
                            >
                              {getRegionName(sembradoData.idregion)}
                            </td>
                          ) : (
                            <td
                              className="px-2 py-3 whitespace-normal text-center"
                              style={
                                idevent === "80"
                                  ? {
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.01)",
                                  }
                                  : {}
                              }
                            ></td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      )}

      <ModalElegirInstitution
        open={open}
        onClose={() => setOpen(false)}
        idevent={idevent}
        idsport={idsport}
        selectedGrupo={selectedGrupo}
        selectedNroGrupo={selectedNroGrupo}
        selectedInstitution={selectedInstitution}
        selectedRegion={selectedRegion}
        setParticipantes={setParticipantes}
        config={config}
        participantes={participantes}
      />
    </div>
  );
};

export default Grupos;
